import Column from '@components/Column';
import Filter from '@components/Filter';
import { StampCardRow, StampCardSorter } from '@models/stamp';
import { useAtom, useAtomValue } from 'jotai';

import styles from './styles.module.scss';
import {
  expandStoreStampIdAtom,
  stampCardSorterAtom,
} from '../../atoms/stampAtoms';

interface Props {
    stampCards?: StampCardRow[];
}

function StampHeader({ stampCards }:Props) {
  const [sort, setSort] = useAtom(stampCardSorterAtom);
  const currentId = useAtomValue(expandStoreStampIdAtom);

  return (
        <Column className={styles.container}
                fullWidth
                spacing={28}>
            <Filter title='보기 설정'
                    className={styles.filterContainer}
                    sort={sort}
                    setSort={setSort}
                    sortItems={[
                      { value: StampCardSorter.IssuedAtDesc, label: '최근 적립순' },
                      { value: StampCardSorter.ShopNameAsc, label: '가나다순' },
                    ]} />
        </Column>
  );
}

export default StampHeader;
